__turbopack_context__.v({
  "actions": "BlockWizard-module__3_wyYa__actions",
  "assumptionItem": "BlockWizard-module__3_wyYa__assumptionItem",
  "assumptions": "BlockWizard-module__3_wyYa__assumptions",
  "close": "BlockWizard-module__3_wyYa__close",
  "cta": "BlockWizard-module__3_wyYa__cta",
  "divider": "BlockWizard-module__3_wyYa__divider",
  "errorBox": "BlockWizard-module__3_wyYa__errorBox",
  "fieldGrid": "BlockWizard-module__3_wyYa__fieldGrid",
  "fieldKey": "BlockWizard-module__3_wyYa__fieldKey",
  "fieldVal": "BlockWizard-module__3_wyYa__fieldVal",
  "header": "BlockWizard-module__3_wyYa__header",
  "heading": "BlockWizard-module__3_wyYa__heading",
  "hint": "BlockWizard-module__3_wyYa__hint",
  "promptArea": "BlockWizard-module__3_wyYa__promptArea",
  "proposal": "BlockWizard-module__3_wyYa__proposal",
  "proposalHeader": "BlockWizard-module__3_wyYa__proposalHeader",
  "proposalTitle": "BlockWizard-module__3_wyYa__proposalTitle",
  "reasoning": "BlockWizard-module__3_wyYa__reasoning",
  "root": "BlockWizard-module__3_wyYa__root",
  "secondary": "BlockWizard-module__3_wyYa__secondary",
  "shimmer": "BlockWizard-module__3_wyYa__shimmer",
  "subtitle": "BlockWizard-module__3_wyYa__subtitle",
  "suggestion": "BlockWizard-module__3_wyYa__suggestion",
  "suggestions": "BlockWizard-module__3_wyYa__suggestions",
  "textarea": "BlockWizard-module__3_wyYa__textarea",
  "thinking": "BlockWizard-module__3_wyYa__thinking",
  "thinkingShimmer": "BlockWizard-module__3_wyYa__thinkingShimmer",
  "title": "BlockWizard-module__3_wyYa__title",
  "toolbar": "BlockWizard-module__3_wyYa__toolbar",
  "typeChip": "BlockWizard-module__3_wyYa__typeChip",
});
